import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { useState } from "react";
import { useI18n } from "../../../../../contexts/i18n.js";
import { FormValueDifferFromTemplateTag } from "../../../valueDifferFromTemplateTag.js";
const FormServiceFieldGeneralPurpose = ()=>{
    const { __ } = useI18n();
    const [ref, setRef] = useState();
    return /*#__PURE__*/ _jsxs(Form.Item, {
        label: __("Purpose"),
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "purpose",
                noStyle: true,
                children: /*#__PURE__*/ _jsx(Input.TextArea, {
                    autoSize: {
                        minRows: 3
                    }
                })
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: "description",
                ref: setRef,
                children: [
                    /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                        form: "service",
                        valueName: "purpose",
                        widthOfRef: ref
                    }),
                    __("The ePrivacy Directive and the GDPR require that a non-professional user understands the purpose of this service, how personal data is collected and how cookies are used for this purpose.")
                ]
            })
        ]
    });
};
export { FormServiceFieldGeneralPurpose };
